import type { ButtonHTMLAttributes, ReactNode } from "react";

type AddActionButtonProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, "children"> & {
    children: ReactNode;
    icon?: string;
};

export function AddActionButton({
    children,
    className = "",
    icon = "add",
    type = "button",
    ...buttonProps
}: AddActionButtonProps) {
    return (
        <button className={["rc-add-action", className].filter(Boolean).join(" ")} type={type} {...buttonProps}>
            <span className="material-icons md-16" aria-hidden="true">{icon}</span>
            <span>{children}</span>
        </button>
    );
}
